import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

const initialIPSearch = {
  IpAddress: "",
  FlagName: "0",
  FacilityID: 0,
  PageNo: 1,
  RowCountPerPage: 10,
  SortField: "",
};

// create slice
const name = "ipActivity";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const IpActivityAction = { ...slice.actions, ...extraActions };
export const IpActivityReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    ipSearchdata: initialIPSearch,
    loading: true,
    getipActivityList: [],
    getipActivityListFullList: [],
    ipActivitylistloading: false,
    getipAddressPUlist: [],
    getipAddressPUFulllist: [],
    ipAddressPUlistloading: false,
    inmateConnectionList: [],
    inmateConnectionFullList: [],
    inmateConnectionLoading: false,
    IpActivityPivotList: [],
  };
}

function createReducers() {
  return {
    clearResponse,
    clearipActivityListFullList,
    cleargetipAddressPUFulllist,
    clearinmateConnectionFullList,
    setIPSearch,
    resetIPSearch,
  };

  function setIPSearch(state, action) {
    state.ipSearchdata = action && action.payload;
  }

  function resetIPSearch(state) {
    state.ipSearchdata = initialIPSearch;
  }

  function clearResponse(state, action) {
    state.InsertResponse = [];
    //state.managePODdata = initialPODData
  }
  function clearipActivityListFullList(state) {
    state.getipActivityListFullList = [];
  }
  function cleargetipAddressPUFulllist(state) {
    state.getipAddressPUFulllist = [];
  }
  function clearinmateConnectionFullList(state) {
    state.inmateConnectionFullList = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/IPActivity`;

  return {
    LoadIPActivityList: LoadIPActivityList(),
    LoadIPAddressBasedPUDetails: LoadIPAddressBasedPUDetails(),
    LoadIPActivityPublicInmateConnectionDetails:
      LoadIPActivityPublicInmateConnectionDetails(),
    LoadPublicUserIPActivityPIVOT: LoadPublicUserIPActivityPIVOT(),
  };

  function LoadIPActivityList() {
    return createAsyncThunk(
      `${name}/LoadIPActivityList`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/LoadIPActivityList`, params)
    );
  }
  function LoadIPAddressBasedPUDetails() {
    return createAsyncThunk(
      `${name}/LoadIPAddressBasedPUDetails`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadIPAddressBasedPUDetails`,
          params
        )
    );
  }

  function LoadIPActivityPublicInmateConnectionDetails() {
    return createAsyncThunk(
      `${name}/LoadIPActivityPublicInmateConnectionDetails`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadIPActivityPublicInmateConnectionDetails`,
          params
        )
    );
  }

  function LoadPublicUserIPActivityPIVOT() {
    return createAsyncThunk(
      `${name}/LoadPublicUserIPActivityPIVOT`,
      async ({ ipAddressState, FacilityId }) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadPublicUserIPActivityPIVOT?iPAddress=${ipAddressState}&facilityID=${FacilityId}`
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    //LoadIPActivityList
    .addCase(extraActions.LoadIPActivityList.pending, (state) => {
      state.ipActivitylistloading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadIPActivityList.fulfilled, (state, action) => {
      const params = action.meta.arg;
      if (params?.exportExcel) {
        state.getipActivityListFullList = action?.payload;
      } else {
        state.getipActivityList = action.payload;
      }

      state.ipActivitylistloading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadIPActivityList.rejected, (state, action) => {
      state.ipActivitylistloading = false;
      state.error = action.error.message;
    })

    //LoadIPAddressBasedPUDetails
    .addCase(extraActions.LoadIPAddressBasedPUDetails.pending, (state) => {
      state.ipAddressPUlistloading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadIPAddressBasedPUDetails.fulfilled,
      (state, action) => {
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.getipAddressPUFulllist = action?.payload;
        } else {
          state.getipAddressPUlist = action.payload;
        }

        state.ipAddressPUlistloading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadIPAddressBasedPUDetails.rejected,
      (state, action) => {
        state.ipAddressPUlistloading = false;
        state.error = action.error.message;
      }
    )
    //LoadIPActivityPublicInmateConnectionDetails
    .addCase(
      extraActions.LoadIPActivityPublicInmateConnectionDetails.pending,
      (state) => {
        state.inmateConnectionLoading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadIPActivityPublicInmateConnectionDetails.fulfilled,
      (state, action) => {
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.inmateConnectionFullList = action?.payload;
        } else {
          state.inmateConnectionList = action.payload;
        }

        state.inmateConnectionLoading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadIPActivityPublicInmateConnectionDetails.rejected,
      (state, action) => {
        state.inmateConnectionLoading = false;
        state.error = action.error.message;
      }
    )
    //IpActivityPivotList
    .addCase(extraActions.LoadPublicUserIPActivityPIVOT.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadPublicUserIPActivityPIVOT.fulfilled,
      (state, action) => {
        state.IpActivityPivotList = action && action.payload;
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadPublicUserIPActivityPIVOT.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    );
  //
}
